import React, { useEffect } from 'react';
import AnnouncementModal from './AnnouncementModal';
import { useAnnouncements } from '@/hooks/useAnnouncements';

const AnnouncementWrapper: React.FC = () => {
  const { announcements, markAsRead, isLoading } = useAnnouncements();
  
  useEffect(() => {
    console.log('[AnnouncementWrapper] State:', {
      isLoading,
      announcementCount: announcements.length,
      announcements
    });
  }, [isLoading, announcements]);
  
  return (
    <AnnouncementModal
      announcements={announcements}
      onClose={markAsRead}
    />
  );
};

export default AnnouncementWrapper;